<ng-container *hasPermissionAny="[Permissions.RCS_Apps_Simulation_Extended_Access]">
  <!-- Header -->
  <div data-cy="advanced-settings">
    <div class="col-12 mt-2">
      <div class="d-flex align-items-center justify-content-between py-1">
        <span
          class="small"
          [ngClass]="
            isExpanded ? 'advanced-settings-label--active' : 'advanced-settings-label--inactive'
          "
          >Advanced Settings</span
        >
        <rb-form-switch
          class="d-block rb-switch-small"
          [checked]="isExpanded"
          [disabled]="false"
          (change)="toggleAdvancedSettings($event)"
          data-cy="advanced-settings-toggle"
        >
        </rb-form-switch>
      </div>
    </div>

    <!-- Always Visible Content - but disabled/enabled based on switch -->
    <div
      class="mt-2 py-2 border-top border-secondary border-opacity-25"
      [class.advanced-settings-disabled]="!isExpanded"
      [class.advanced-settings-enabled]="isExpanded"
      data-cy="advanced-settings-content"
    >
      <div class="d-flex flex-wrap align-items-center gap-3">
        <!-- Confidence Setting -->
        <div class="d-flex align-items-center gap-2 ps-0" data-cy="confidence-setting">
          <label
            class="small"
            [ngClass]="
              isExpanded ? 'advanced-settings-label--active' : 'advanced-settings-label--inactive'
            "
          >
            Confidence:
          </label>
          <input
            type="number"
            class="advanced-settings-input form-control form-control-sm border-0 shadow-none"
            [ngClass]="
              isExpanded ? 'advanced-settings-input--active' : 'advanced-settings-input--inactive'
            "
            style="width: 70px"
            min="0"
            max="1.0"
            step="0.01"
            [value]="confidence"
            [disabled]="!isExpanded"
            (input)="updateConfidence($event)"
            data-cy="confidence-input"
          />
        </div>

        <!-- DFRS Classification -->
        <div class="d-flex align-items-center gap-2 ps-0" data-cy="dfrs-setting">
          <label
            class="small mb-0"
            [ngClass]="
              isExpanded ? 'advanced-settings-label--active' : 'advanced-settings-label--inactive'
            "
          >
            DFRS Classification:
          </label>
          <select
            class="advanced-settings-input form-select form-select-sm border-0 shadow-none"
            [ngClass]="
              isExpanded ? 'advanced-settings-input--active' : 'advanced-settings-input--inactive'
            "
            style="width: 130px"
            [value]="dfrs"
            [disabled]="!isExpanded"
            (change)="updateDfrsClassification($event)"
            data-cy="dfrs-select"
          >
            <option *ngFor="let option of dfrsOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-container>
